export default class ColumnExcel {
  constructor(label, key, required, maxLength, type) {
    this.label = label || '';
    this.key = key || label;
    this.maxLength = maxLength || 4000;
    this.required = required || false;
    this.type = type || 'string';
  }

  checkValue(value) {
    const errors = [];
    if (value && value.length > this.maxLength) {
      errors.push(`${this.label}_MAX_LENGTH_${this.maxLength.toString()}`);
    }
    if (!value?.trim() && this.required) {
      errors.push(`${this.label}_IS_REQUIRED`);
    }
    return errors;
  }
}
